/**
 * The well-known name of the cookie used to store a Prismic preview session's ref.
 */
export const preview = "io.prismic.preview";
